module.exports = __webpack_public_path__ + "fonts/Barlow-SemiBold.aca6911b.woff2";